import { DATE_FORMAT } from '@app/configs/dateTime';
import { getLocalDateTime } from '@app/utils/time';
import formatAmount from '@modules/calculator/utils/formatAmount';
import CreditScoreLabelMobile from '../components/common/CreditScoreLabelMobile';
import { getFundingProgress } from './getFundingProgress';
export const getOpportunityRows = (opportunity, t) => [
    {
        key: 'id',
        label: t('financing.investing_page_table.id'),
        value: opportunity.id,
    },
    {
        key: 'investmentDeadline',
        label: t('financing.investing_page_table.investment_deadline'),
        value: getLocalDateTime(opportunity.investmentDeadline, DATE_FORMAT.dateTime),
    },
    {
        key: 'loanAmount',
        label: t('financing.investing_page_table.asked_amount'),
        value: `${formatAmount(opportunity.loanAmount, true, false)} ${opportunity.loanCurrency}`,
    },
    {
        key: 'loanPurpose',
        label: t('financing.investing_page_table.loan_purpose'),
        value: {
            className: 'block w-full text-right',
            text: opportunity.loanPurpose,
        },
    },
    {
        key: 'loanPeriod',
        label: t('financing.investing_page_table.period'),
        value: `${opportunity.loanPeriod} ${t('financing.investing_page_table.months')}`,
    },
    {
        key: 'roi',
        label: t('financing.investing_page_table.roi'),
        value: `${opportunity.roi}%`,
    },
    {
        key: 'riskScore',
        label: CreditScoreLabelMobile(),
        value: opportunity.riskScore,
    },
    {
        key: 'fundingProgress',
        label: t('financing.investing_page_table.funding_progress'),
        value: getFundingProgress(opportunity),
    },
];
